export const capitalize = (word: string) => `${word[0].toUpperCase()}${word.slice(1).toLowerCase()}`;

export const decodeStringWithHtmlEntities = (encodedStr: string) => {
  const txt = document.createElement('textarea');
  txt.innerHTML = encodedStr;
  return txt.value;
};
